.standardCell:hover {
  opacity: 0.7;
  background-color: #f6f6f6;
}
